import z from 'zod'

import validDynamicRoutesConfig from '@/legacy-src/config/validDynamicRoutesConfig.json'
import { localeConfig } from '@/legacy-src/constants/locale.config'

export type Locale = keyof typeof localeConfig

export const locales = Object.keys(localeConfig) as Locale[]

const LocaleSchema = z.enum(locales as [Locale, ...Locale[]])

export const LOCALE = LocaleSchema.parse(process.env.NEXT_PUBLIC_LOCALE)

export const PUBLIC_THERAPISTS_PAGE_SLUG = validDynamicRoutesConfig.locales[LOCALE]
export const PUBLIC_THERAPISTS_PAGE_URL = `${process.env.NEXT_PUBLIC_WORDPRESS_WEB}${PUBLIC_THERAPISTS_PAGE_SLUG}`

export const getPublicTherapistSlugForLocale = (locale: Locale) => validDynamicRoutesConfig.locales[locale]

export const isRoutePublicTherapistList = (route: string) =>
  route.includes(PUBLIC_THERAPISTS_PAGE_SLUG) || route.includes(encodeURIComponent(PUBLIC_THERAPISTS_PAGE_SLUG))
